var React = require('react');

function ArrowDropDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.04297 5L0.0429688 0H10.043L5.04297 5Z","fill":"currentColor"}));
}

ArrowDropDown.defaultProps = {"width":"11","height":"5","viewBox":"0 0 11 5","fill":"none"};

module.exports = ArrowDropDown;

ArrowDropDown.default = ArrowDropDown;
